"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var Observable_1 = require("rxjs/Observable");
var category_permission_type_1 = require("../../model/category-permission-type");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var HttpPermissionConfigurationService = /** @class */ (function () {
    function HttpPermissionConfigurationService(applicationPropertiesService, http) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
    }
    HttpPermissionConfigurationService_1 = HttpPermissionConfigurationService;
    HttpPermissionConfigurationService.prototype.getPermissionTabs = function (languageId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        var params = new http_1.HttpParams();
        params = params.set('languageId', languageId.toString());
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSION_TABS).flatMap(function (url) {
            return _this.http.get(url, { params: params })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getTabPermissions = function (labels, languageId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        var params = new http_1.HttpParams();
        params = params.set('languageId', languageId.toString());
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.TAB_PERMISSIONS).flatMap(function (url) {
            return _this.http.post(url, labels, { params: params })
                .map(function (permissionObjects) { return _this.extractPermissionsData(permissionObjects); })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getPermissionGroups = function (languageId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        var params = new http_1.HttpParams();
        params = params.set('languageId', languageId.toString());
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSION_GROUPS).flatMap(function (url) {
            return _this.http.get(url, { params: params })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getServicePermissionKey = function (serviceKey) {
        var _this = this;
        var params = new http_1.HttpParams();
        params = params.set('serviceKey', serviceKey);
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSION_SERVICE_KEY).flatMap(function (url) {
            return _this.http.get(url, { params: params, responseType: 'text' })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getCategoryPermissionKey = function (categorySystemName, permissionType) {
        var _this = this;
        var params = new http_1.HttpParams();
        params = params.set('categorySystemName', categorySystemName);
        params = params.set('permissionType', category_permission_type_1.CategoryPermissionType[permissionType].toString());
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSION_CATEGORY_KEY).flatMap(function (url) {
            return _this.http.get(url, { params: params, responseType: 'text' })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getCategoryPermissions = function () {
        var _this = this;
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSION_CATEGORYS).flatMap(function (url) {
            return _this.http.get(url)
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getPermissions = function (permissionFilter, languageId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        var params = new http_1.HttpParams();
        params = params.set('languageId', languageId.toString());
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSIONS_SEARCH).flatMap(function (url) {
            return _this.http.post(url, permissionFilter, { params: params })
                .map(function (permissionObjects) { return _this.extractPermissions(permissionObjects); })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.getCategoryConditionalPermissionsExpressions = function (permissionKeys) {
        var _this = this;
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSIONS_CONDITIONAL_PERMISSIONS_EXPRESSIONS).flatMap(function (url) {
            return _this.http.post(url, permissionKeys, {})
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.createCategoryConditionalPermission = function (categoryConditionalPermissionDto) {
        var _this = this;
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSIONS_CONDITIONAL_PERMISSION).flatMap(function (url) {
            return _this.http.post(url, categoryConditionalPermissionDto, { responseType: "text" })
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.updateCategoryConditionalPermission = function (categoryConditionalPermissionDto) {
        var _this = this;
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSIONS_CONDITIONAL_PERMISSION).flatMap(function (url) {
            return _this.http.put(url, categoryConditionalPermissionDto, {})
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.createCategoryConditionalPermissions = function (categoryConditionalPermissionDtos) {
        var _this = this;
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSIONS_CONDITIONAL_PERMISSIONS).flatMap(function (url) {
            return _this.http.post(url, categoryConditionalPermissionDtos)
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.updateCategoryConditionalPermissions = function (categoryConditionalPermissionDtos) {
        var _this = this;
        return this.getPermissionServiceUrl(HttpPermissionConfigurationService_1.PERMISSIONS_CONDITIONAL_PERMISSIONS).flatMap(function (url) {
            return _this.http.put(url, categoryConditionalPermissionDtos, {})
                .catch(function (error) { return Observable_1.Observable.throw(error); });
        });
    };
    HttpPermissionConfigurationService.prototype.extractPermissions = function (permissionObjects) {
        var permissions = [];
        permissionObjects.forEach(function (permissionObject) {
            var permission = {};
            permission.id = permissionObject.key;
            permission.name = permissionObject.name;
            permissions.push(permission);
        });
        return permissions;
    };
    HttpPermissionConfigurationService.prototype.extractPermissionsData = function (permissionObjects) {
        var permissions = [];
        permissionObjects.forEach(function (permissionObject) {
            var permission = {};
            permission.id = permissionObject.key;
            permission.name = permissionObject.name;
            idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(permissionObject.permissionLabelDtos);
            permissionObject.permissionLabelDtos.forEach(function (label) {
                if (label.name == "parentId") {
                    permission.parentId = +label.value;
                }
                else if (label.name == "sortId") {
                    permission.sortId = +label.value;
                }
                else {
                    permission[label.name] = label.value;
                }
            });
            idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(permission.sortId);
            idm_common_util_frontend_1.PreconditionCheck.notUndefined(permission.parentId);
            permissions.push(permission);
        });
        return permissions;
    };
    HttpPermissionConfigurationService.prototype.getPermissionServiceUrl = function (extension) {
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService
            .getProperty(HttpPermissionConfigurationService_1.PERMISSION_SERVICE_URL_KEY)
            .then(function (umServiceBase) { return umServiceBase + "/" + extension; }))
            .catch(function (error) { return Observable_1.Observable.throw(error); });
    };
    HttpPermissionConfigurationService.PERMISSION_SERVICE_URL_KEY = 'um-permission-service-url';
    HttpPermissionConfigurationService.TAB_PERMISSIONS = "permissions/";
    HttpPermissionConfigurationService.PERMISSION_TABS = "permissions/tabs";
    HttpPermissionConfigurationService.PERMISSION_GROUPS = "permissions/groups";
    HttpPermissionConfigurationService.PERMISSION_SERVICE_KEY = "permissions/servicepermissionkey";
    HttpPermissionConfigurationService.PERMISSION_CATEGORY_KEY = "permissions/categorypermissionkey";
    HttpPermissionConfigurationService.PERMISSION_CATEGORYS = "permissions/categorypermissions";
    HttpPermissionConfigurationService.PERMISSIONS_SEARCH = "permissions/search";
    HttpPermissionConfigurationService.PERMISSIONS_CONDITIONAL_PERMISSIONS_EXPRESSIONS = "permissions/categoryconditionalpermissionsexpressions";
    HttpPermissionConfigurationService.PERMISSIONS_CONDITIONAL_PERMISSION = "permissions/categoryconditionalpermission";
    HttpPermissionConfigurationService.PERMISSIONS_CONDITIONAL_PERMISSIONS = "permissions/categoryconditionalpermissions";
    HttpPermissionConfigurationService = HttpPermissionConfigurationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], HttpPermissionConfigurationService);
    return HttpPermissionConfigurationService;
    var HttpPermissionConfigurationService_1;
}());
exports.HttpPermissionConfigurationService = HttpPermissionConfigurationService;
//# sourceMappingURL=http-permission-configuration.service.js.map